import Browse from "@/modules/browse/browse-layout"
import BrowseRouter from "@/modules/browse/browse-router"
import Documents from "@/modules/browse/browse-documents"
import Folders from "@/modules/browse/browse-folders"

const BrowseRouterExp = {
	path: "/browse",
	name: "browse",
	component: BrowseRouter,
	children: [
		{
			path: "",
			name: "browse.home",
			component: Browse
		},
		{
			path: "home",
			name: "browse.home",
			component: Browse
		},
		{
			path: "all-docs",
			name: "browse.all-docs",
			component: Documents,
			props: true
		},
		{
			path: "folders",
			name: "browse.folders",
			component: Folders,
			props: true
		},
		{
			path: "folders/:folder_id",
			name: "browse.folders.folder_id",
			component: Documents,
			props: true
		}
	]
}

export default BrowseRouterExp
